import '@styles/iris-weather.scss'
import Cookies from 'js-cookie'

export default class WeatherCpnt {
    static units = ['metric', 'imperial']

    constructor() {
        WeatherCpnt.switch()
        WeatherCpnt.accordion()

        // On triggering scope temperature_unit
        $(document).on('temperature_unit', (event, data) => {
            WeatherCpnt.setUnit(data.value)
            WeatherCpnt.calculateValuesTemp()
            WeatherCpnt.calculateValuesWind()
        })

        WeatherCpnt.calculateValuesTemp()
        WeatherCpnt.calculateValuesWind()
    }

    // Get selected unit in string
    static getUnit() {
        if (Cookies.get('temperature_unit')) {
            return WeatherCpnt.units[Cookies.get('temperature_unit')]
        }

        return WeatherCpnt.units[0]
    }

    // Get selected value
    static getValue() {
        if (Cookies.get('temperature_unit')) {
            return Cookies.get('temperature_unit') * 1
        }

        return 0
    }

    // Set new value (unit)
    static setUnit(value) {
        Cookies.set('temperature_unit', value)
    }

    // Calculate rending values using selected unit
    static calculateValuesTemp() {
        $('.weather-array__weather--temp').each(function () {
            let value = Number.parseFloat($(this).data('temp'))

            if (WeatherCpnt.getUnit() === 'imperial') {
                value = (value * 9) / 5 + 32
                $(this).text(`${value.toFixed(1)} °F`)
            } else if (WeatherCpnt.getUnit() === 'metric') {
                $(this).text(`${Math.floor(value)} °C`)
            }
        })
    }

    // Calculate rending values using selected unit
    static calculateValuesWind() {
        $('[data-wind]').each(function () {
            let value = Number.parseFloat($(this).data('wind'))

            if (WeatherCpnt.getUnit() === 'imperial') {
                value = (value / 1.609344).toFixed(2)
                $(this).text(`${value} mph`)
            } else if (WeatherCpnt.getUnit() === 'metric') {
                $(this).text(`${value} km/h`)
            }
        })
    }

    static switch() {
        const trigger = '.wp-block-weather [data-trigger="wpiris-switch"]'
        let newValue = 0

        if ($(trigger).length > 0) {
            $(document).on('click', trigger, function (e) {
                e.preventDefault()
                const value = $(this).attr('data-switch-active')

                $(this).toggleClass('switch--checked')

                if ('0' === value) {
                    $(this).attr('data-switch-active', 1)
                    newValue = 1
                } else {
                    $(this).attr('data-switch-active', 0)
                    newValue = 0
                }

                $(document).trigger($(trigger).data('scope'), {
                    value: newValue,
                })
            })
        }
    }

    static accordion() {
        $('.wp-block-weather [data-role="iris-accordion"]').each(function () {
            const accordion = $(this)
            const trigger = $(accordion).find('[data-trigger="iris-accordion-trigger"]')
            const content = $(accordion).find('[data-element="iris-accordion-content"]')

            accordion.addClass('close')
            content.addClass('close')
            trigger.addClass('close')

            trigger.click(() => {
                accordion.toggleClass('close').toggleClass('open')
                content.toggleClass('close').toggleClass('open')
                trigger.toggleClass('close').toggleClass('open')
            })
        })
    }
}
